module.exports = __webpack_public_path__ + "static/media/004.98604d4c.jpg";